/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_StartInputs */



/**
* | output |
* | --- |
* | "Start Time" |
*
* @param {Transcript_Export_Field_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_start = /** @type {((inputs?: Transcript_Export_Field_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Start Time")
	if (locale === "de") return /** @type {LocalizedString} */ ("Start Time")
	if (locale === "it") return /** @type {LocalizedString} */ ("Start Time")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Start Time")
	if (locale === "es") return /** @type {LocalizedString} */ ("Start Time")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Start Time")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Start Time")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Start Time")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Start Time")
	return /** @type {LocalizedString} */ ("Start Time")
});